export default {"src":"/_next/static/media/gear.5b8d42da.svg","height":512,"width":512};